import { useMatchScreen } from '../../context/MatchScreenContext'
import { useModuleConfig } from './useModuleConfig'
import { MODULE_KEYS, SELF_SCHEDULING_DEFAULTS } from '../moduleRegistry'

// Quick-testing toggle. When `true`, gate on the Optimizely module flag only and bypass
// the session signals (`selfSchedulingEnabled` / `revisit`) that aren't wired up downstream
// yet — useful for exercising the flow in preprod. Set to `false` before the production launch.
// Exported so the eligibility tests can assert against the live value rather than hardcoding it.
export const MODULE_GATE_ONLY = false

/**
 * Whether the self-scheduling experience may render. Every gate must be open:
 * 1. the Optimizely variation enables the `self_scheduling_module`,
 * 2. this is not an admin advisor preview,
 * 3. the session has self-scheduling enabled, and
 * 4. the user is not revisiting the match screen.
 *
 * The session gates (3, 4) can be bypassed for testing via `MODULE_GATE_ONLY`.
 * The preview gate is deliberately NOT bypassable: a preview must never book
 * real appointments, including under the testing toggle.
 */
export const useSelfSchedulingEligibility = (): boolean => {
  const { enabled: moduleEnabled } = useModuleConfig(MODULE_KEYS.selfScheduling, SELF_SCHEDULING_DEFAULTS)
  const { state: { selfSchedulingEnabled, revisit, isPreview } } = useMatchScreen()

  return moduleEnabled && !isPreview && (MODULE_GATE_ONLY || (selfSchedulingEnabled && !revisit))
}
